module.exports = __webpack_public_path__ + "img/Apoptosis-CRC_10X_TGSP.c42d3792.png";